import moment from 'moment';

export interface GoogleAdsBlockedInfo {
    isBlocked: boolean,
    blockedUntil: string
}

export function useGoogleAdsBlockedInfo(retryAtTime: string): GoogleAdsBlockedInfo {

    if (retryAtTime === undefined) {
        return {
            isBlocked: false,
            blockedUntil: ''
        };
    }

    const blockedUntil = moment.utc(retryAtTime).add(30, 'seconds');
    const diff = moment.duration(moment().diff(blockedUntil));
    const isBlocked = diff.as('seconds') < 0;

    return {
        isBlocked: isBlocked,
        blockedUntil: blockedUntil.fromNow()
    };
}
